import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Output } from '@angular/core';

import { SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'ms-my-bets-migration-info',
    templateUrl: 'my-bets-migration-info.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MyBetsMigrationInfoComponent {
    @HostBinding('class') className = 'betslip-taxation-info betslip-migration-info';
    @Output() close = new EventEmitter<boolean>();
    constructor(public sitecoreMyBets: SitecoreMyBetsConfig) {}
    okClick(): void {
        this.close.emit();
    }
}
